import { associatesTableColumns } from '../../constants/tableColumns';
import useAssociateActions from '../../hooks/APIHooks/users/useAssociateActions';
import useCheckUserFeaturePermissions from '../../hooks/useCheckUserFeaturePermissions';
import AcademiaNotFound from '../CommonComps/AcademiaNotFound';
import AcademiaLoading from '../CommonComps/Loadings/AcademiaLoading';
import AcademiaTable from '../CommonComps/Tables/AcademiaTable';
import PageHeader from '../CommonComps/Titles/PageHeader';
import CreateAssociateAction from './CreateAssociateAction';

const ShowAllAssociates = () => {
  // integration of custom hooks here
  const { associateListHandler } = useAssociateActions('associateList');

  const { featureBasedPermissions } = useCheckUserFeaturePermissions('users');

  console.log('ASSOCIATE LIST: ', associateListHandler.data?.data);

  // rendering show all users section component here
  return (
    <section>
      {associateListHandler.isLoading ? (
        <AcademiaLoading />
      ) : associateListHandler.isSuccess ? (
        featureBasedPermissions?.includes('READ') ? (
          <>
            <PageHeader headerText='All Associates' />
            <AcademiaTable
              data={associateListHandler.data.data}
              columns={associatesTableColumns}
              tableToolbarComponent={
                <CreateAssociateAction
                  hasCreatePermission={featureBasedPermissions.includes(
                    'CREATE'
                  )}
                />
              }
              notFoundMessage='No associate found!'
            />
          </>
        ) : (
          <AcademiaLoading />
        )
      ) : associateListHandler.isError ? (
        <AcademiaNotFound message='Failed to load associate data!!' />
      ) : null}
    </section>
  );
};

export default ShowAllAssociates;
